(() => {
    window.dataLayer = window.dataLayer || [];

    fetch('/?section_id=customer-segment-filter', { credentials: 'same-origin' })
        .then((r) => (r.ok ? r.text() : ''))
        .then((html) => {
            const doc = new DOMParser().parseFromString(html, 'text/html');
            const variantInfo = doc.querySelector('[data-csf-variant]');
            if (!variantInfo) return;

            const variantName = variantInfo.getAttribute('data-csf-variant');

            try {
                window.dataLayer.push({
                    event: 'experiment_impression',
                    exp_variant_string: `silver-filter--segment-${variantName}`,
                });
            }
            catch(e) { console.error('[SEGMENT] g4a push error', e); }

            const filterValue = variantInfo.getAttribute('data-csf');
            if (!filterValue) return;
            initFilter(decodeURIComponent(filterValue));
        })
        .catch((e) => console.error(e));

    function initFilter(filterValue) {
        const FILTER_KEY = 'filter.v.option.color';
        const FILTER = `${FILTER_KEY}=${encodeURIComponent(filterValue)}`;

        document.addEventListener(
            'click',
            (e) => {
                const a = e.target.closest?.('a[href*="/collections/"]');
                if (!a || a.closest('facet-remove')) return;

                const href = a.getAttribute('href');
                if (!href || href.includes(FILTER_KEY)) return;

                const hashIndex = href.indexOf('#');
                const hash = hashIndex !== -1 ? href.slice(hashIndex) : '';
                const base = hashIndex !== -1 ? href.slice(0, hashIndex) : href;
                a.setAttribute('href', `${base}${base.includes('?') ? '&' : '?'}${FILTER}${hash}`);
            },
            true
        );

        initSwatchAutoSelect();
    }

    function initSwatchAutoSelect() {
        const SELECTOR = '.instant-variant-picker input[value="Silver"], input[data-variant-color="silver"]';

        const selectSilver = (root = document) => {
            root.querySelectorAll?.(SELECTOR).forEach((el) => {
                if (el.dataset.csfDone || el.checked) return;
                el.dataset.csfDone = '1';
                el.click();
                el.cecked = true;
            });
        };

        const start = () => {
            selectSilver();
            new MutationObserver((mutations) => {
                for (const m of mutations) {
                    for (const node of m.addedNodes) {
                        if (node.nodeType === 1) selectSilver(node);
                    }
                }
            }).observe(document.body, { childList: true, subtree: true });
        };

        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', start);
        } else {
            start();
        }
    }
})();